import debounce from 'lodash/debounce';
import { WtrDispatch } from 'redux/hooks';
import { AUTOSUGGEST_FULFILLED } from 'redux/modules/auto-suggest/actions/types';
import termSuggestService from 'services/termSuggest';

export const autoSuggestSearchAction = async (searchTerm: string) => {
  const term = searchTerm.trim();
  if (term.length) {
    const results = await termSuggestService.getSuggestions(searchTerm);
    return {
      type: AUTOSUGGEST_FULFILLED,
      result: {
        terms: results,
        empty: !results.length,
      },
      searchTerm,
    };
  }
  return null;
};

const autoSuggestSearchDebouncer = debounce(
  async (dispatch, searchTerm) => {
    const action = await autoSuggestSearchAction(searchTerm);
    if (action) dispatch(action);
  },
  300,
  { leading: true, maxWait: 600 },
);

export default (searchTerm: string) => (dispatch: WtrDispatch) =>
  autoSuggestSearchDebouncer(dispatch, searchTerm);
